import { appendMJAspectRatio, normalizeMJAspectRatioParam, stripMJFlags } from '../tools';

// Midjourney 提示词构建工具（youchuan 专用）
// 服务端控制的参数，用户在 prompt 中手写的会被剥离
const SERVER_CONTROLLED_MJ_FLAGS = [
    'fast',
    'turbo',
    'hd',
    'aspect',
    'ar',
    'quality',
    'q',
    'version',
    'v',
    'niji',
] as const;

const YOUCHUAN_ALLOWED_ASPECT_RATIOS = [
    '21:9',
    '16:9',
    '9:16',
    '5:4',
    '4:5',
    '4:3',
    '3:4',
    '3:2',
    '2:3',
    '1:1',
] as const;

function applyHdByResolution(prompt: string, image_resolution?: string): string {
    if (image_resolution !== '2K') {
        return prompt;
    }
    return prompt ? `${prompt} --hd` : '--hd';
}

function applyMJVersion(prompt: string, version: string): string {
    return prompt ? `${prompt} --v ${version}` : `--v ${version}`;
}

function applyMJNijiVersion(prompt: string, version: string): string {
    return prompt ? `${prompt} --niji ${version}` : `--niji ${version}`;
}

export function buildFinalPrompt(params: {
    prompt: string;
    aspectRatio?: string;
    image_resolution?: string;
    mjVersion: string;
    useNiji?: boolean;
    supportsImageResolution?: boolean;
}): string {
    const { prompt, aspectRatio, image_resolution, mjVersion, useNiji, supportsImageResolution } = params;
    const normalized = normalizeMJAspectRatioParam(prompt ?? '');
    const sanitized = stripMJFlags(normalized, SERVER_CONTROLLED_MJ_FLAGS);
    const withAspect = appendMJAspectRatio(
        sanitized,
        aspectRatio,
        YOUCHUAN_ALLOWED_ASPECT_RATIOS,
        '1:1'
    );
    const withHd = supportsImageResolution
        ? applyHdByResolution(withAspect, image_resolution)
        : withAspect;
    const withVersion = useNiji
        ? applyMJNijiVersion(withHd, mjVersion)
        : applyMJVersion(withHd, mjVersion);
    return withVersion.slice(0, 8192);
}